import { useState } from 'react';
import './App.css';
import MainMenu from './components/MainMenu';
import GameBoard from './components/GameBoard';

function App() {
  const [currentScreen, setCurrentScreen] = useState('menu');
  const [gameType, setGameType] = useState(null);

  const handleGameSelect = (type) => {
    setGameType(type);
    setCurrentScreen('game');
  };

  const handleBackToMenu = () => {
    setCurrentScreen('menu');
    setGameType(null);
  };

  return (
    <div className="App">
      {currentScreen === 'menu' ? (
        <MainMenu onSelectGame={handleGameSelect} />
      ) : (
        <GameBoard gameType={gameType} onBackToMenu={handleBackToMenu} />
      )}
    </div>
  );
}

export default App;
